// Checklist - MAP (about)

page.checklist.zemelapis = {
    enabled: false,
    ready: false,
    needsLoad: false,
    progress: 0,
    scene: null,
    tl:null,
    check: function(){
        this.reset();
        if(page.v.firstLoad) this.first();

        if($('#worldMap').length > 0){
            log.page("CHECK: Map detected (about)", 2);
            this.enabled = true;
        }
    },
    reset: function(){
        this.enabled = false;
        this.ready = false;
        this.needsLoad = false;
        this.progress = 0;
    },
    init: function(){

        let name = $('.barba-container').data('namespace');
        page.transitions(name, 900);

        TweenMax.set($('.map-line'), { drawSVG : '0', stroke: '#0AD383'});
        TweenMax.set($('.mPoint'), { autoAlpha: 0, scale: 0})

        let points = $('.mPoint');

        function shuffleArray(array) {
            for (var i = array.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                var temp = array[i];
                array[i] = array[j];
                array[j] = temp;
            }
        }

        shuffleArray(points);

        let tl = new TimelineMax({paused:true});
        tl.staggerTo(points, 0.15, {autoAlpha: 1, scale: 1}, 0.05)
        let contr = page.main.fr.magicScroll.controller;
        let scene = new ScrollMagic.Scene(
            {
                triggerElement: $('.section-worldmap')[0],
                triggerHook: 0.4
            })
            .addTo(contr);

        scene.on('start', function(event){
            tl.play();
        });

        if($(window).width() < 1024){
            tl.play();
        }

        page.checklist.zemelapis.scene = scene;

        let lietuva = new TimelineMax({paused:true});
        let latvia = new TimelineMax({paused:true});
        let estija = new TimelineMax({paused:true});
        let rusija = new TimelineMax({paused:true});
        let danija = new TimelineMax({paused:true});
        let vokietija = new TimelineMax({paused:true});
        let ukraina = new TimelineMax({paused:true});
        let uk = new TimelineMax({paused:true});
        let suomija = new TimelineMax({paused:true});
        let lenkija = new TimelineMax({paused:true});
        let svedija = new TimelineMax({paused:true});
        let kazachstanas = new TimelineMax({paused:true});
        let brazilija = new TimelineMax({paused:true});

        lietuva.to($('.line-lietuva'), 0.4, { drawSVG: '0 100%'});
        latvia.to($('.line-latvija'), 0.4, { drawSVG: '0 100%'});
        estija.to($('.line-estija'), 0.4, { drawSVG: '0 100%'});
        rusija.to($('.line-rusija'), 0.4, { drawSVG: '0 100%'});
        danija.to($('.line-danija'), 0.4, { drawSVG: '0 100%'});
        ukraina.to($('.line-ukraina'), 0.4, { drawSVG: '0 100%'});
        vokietija.to($('.line-vokietija'), 0.4, { drawSVG: '0 100%'});
        uk.to($('.line-anglija'), 0.4, { drawSVG: '0 100%'});
        suomija.to($('.line-suomija'), 0.4, { drawSVG: '0 100%'});
        lenkija.to($('.line-lenkija'), 0.4, { drawSVG: '0 100%'});
        svedija.to($('.line-svedija'), 0.4, { drawSVG: '0 100%'});
        brazilija.to($('.line-brazilija'), 0.4, { drawSVG: '0 100%'});
        kazachstanas.to($('.line-kazachstanas'), 0.4, { drawSVG: '0 100%'});

        $('.map-land--hover').click(function(e){
            let $this = $(this);
            let land = $this.data('type');

            if($this.hasClass('active')){
                reverse();
                $this.removeClass('active');
                return false;
            }

            $('.map-land--hover').removeClass('active');
            $this.addClass('active');



            function reverse(){
                if(brazilija.progress() !== 0){
                    brazilija.reverse();
                }
                if(kazachstanas.progress() !== 0){
                    kazachstanas.reverse();
                }

                if(lietuva.progress() !== 0){
                    lietuva.reverse();
                }
                if(latvia.progress() !== 0){
                    latvia.reverse();
                }
                if(estija.progress() !== 0){
                    estija.reverse();
                }
                if(rusija.progress() !== 0){
                    rusija.reverse();
                }
                if(danija.progress() !== 0){
                    danija.reverse();
                }
                if(vokietija.progress() !== 0){
                    vokietija.reverse();
                }
                if(uk.progress() !== 0){
                    uk.reverse();
                }
                if(suomija.progress() !== 0){
                    suomija.reverse();
                }
                if(lenkija.progress() !== 0){
                    lenkija.reverse();
                }
                if(ukraina.progress() !== 0){
                    ukraina.reverse();
                }
                if(svedija.progress() !== 0){
                    svedija.reverse();
                }

            }
            reverse();

            if(land == 'brazilija'){
                brazilija.play();
            }
            if(land == 'kazachstanas'){
                kazachstanas.play();
            }
            if(land == 'lietuva'){
                lietuva.play();
            }
            if(land == 'latvija'){
                latvia.play();
            }
            if(land == 'estija'){
                estija.play();
            }
            if(land == 'rusija'){
                rusija.play();
            }
            if(land == 'danija'){
                danija.play();
            }
            if(land == 'vokietija'){
                vokietija.play();
            }
            if(land == 'uk'){
                uk.play();
            }
            if(land == 'suomija'){
                suomija.play();
            }
            if(land == 'lenkija'){
                lenkija.play();
            }
            if(land == 'ukraina'){
                ukraina.play();
            }
            if(land == 'svedija'){
                svedija.play();
            }

        });

        $(".section-worldmap").mouseleave(function(e){
            $('.map-land--hover').removeClass('active');

            if(brazilija.progress() !== 0){
                brazilija.reverse();
            }
            if(kazachstanas.progress() !== 0){
                kazachstanas.reverse();
            }

            if(lietuva.progress() !== 0){
                lietuva.reverse();
            }
            if(latvia.progress() !== 0){
                latvia.reverse();
            }
            if(estija.progress() !== 0){
                estija.reverse();
            }
            if(rusija.progress() !== 0){
                rusija.reverse();
            }
            if(danija.progress() !== 0){
                danija.reverse();
            }
            if(vokietija.progress() !== 0){
                vokietija.reverse();
            }
            if(uk.progress() !== 0){
                uk.reverse();
            }
            if(suomija.progress() !== 0){
                suomija.reverse();
            }
            if(lenkija.progress() !== 0){
                lenkija.reverse();
            }
            if(ukraina.progress() !== 0){
                ukraina.reverse();
            }
            if(svedija.progress() !== 0){
                svedija.reverse();
            }

        })

    },
    initRun: function(){
        var $world = $('#worldMap');
        var v = this.v;


        v.setWorld = new TimelineMax();
        v.setWorld
            .set($('#worldMap circle'), {autoAlpha: 0})
            .set($('#Lietuva path'),{drawSVG :0})
            .set($('#Latvija path'),{drawSVG :0})
            .set($('#Estija path'),{drawSVG :0})
            .set($('#Rusija path'),{drawSVG :0})
            .set($('#Vokietija path'),{drawSVG :0})
            .set($('#Svedija path'),{drawSVG :0})
            .set($('#Ukraina path'),{drawSVG :0})
            .set($('#Anglija path'),{drawSVG :0})
            .set($('#Suomija path'),{drawSVG :0})
            .set($('#Danija path'),{drawSVG :0})
            .set($('#Lenkija path'),{drawSVG :0});

        v.worldl = new TimelineMax({paused: true});
        v.worldl.pause();

        var lt_delivery = $(
            "#salis_173 , #salis_174 , #salis_175 , #salis_172 , #salis_171 , #salis_162 , #salis_163 , #salis_161 , #salis_166 , #salis_167 , #salis_168 , #salis_169 , #salis_165 , #salis_160 , #salis_158 , #salis_156 , #salis_114 , #salis_152 , #salis_159 , #salis_157 , #salis_119 , #salis_155 , #salis_151 , #salis_144 , #salis_150 , #salis_164 , #salis_147 , #salis_104 , #salis_176 , #salis_145 , #salis_148 , #salis_149"
        );

        var lv_delivery = $(
            "#salis_172,#salis_105,#salis_171,#salis_173,#salis_174,#salis_175,#salis_169,#salis_162,#salis_23,#salis_11,#salis_17,#salis_18,#salis_160,#salis_30,#salis_159,#salis_157,#salis_150,#salis_151,#salis_172,#salis_105,#salis_165,#salis_163,#salis_158,#salis_156,#salis_153,#salis_119,#salis_107,#salis_152,#salis_79,#salis_81,#salis_110,#salis_146,#salis_70,#salis_9,#salis_168,#salis_161"
        );

        var ee_delivery = $(
            "#salis_168,#salis_70,#salis_163,#salis_151,#salis_149,#salis_174,#salis_173,#salis_161,#salis_149" );
///170
        var  ru_delivery = $(
            "#salis_174,#salis_173,#salis_169,#salis_171,#salis_165,#salis_17,#salis_160,#salis_159,#salis_130,#salis_117,#salis_73,#salis_64,#salis_63,#salis_156");

        var dk_delivery = $(
            '#salis_168,#salis_161'
        );

        var de_delivery = $(
            '#salis_151'
        );

        var se_delivery = $(
            '#salis_168,#salis_163,#salis_64'
        );

        var ua_delivery = $(
            "#salis_105,#salis_169,#salis_166,#salis_162,#salis_23,#salis_30,#salis_0,#salis_158,#salis_119,#salis_153,#salis_139,#salis_149,#salis_9"
        );

        var uk_delivery = $(
            '#salis_156'
        );

        var fi_delivery = $('#salis_64');

        var pl_delivery = $('#salis_169, #salis_174');

        var t_opacity = 0.35;
        var t_fade = 0.5;
        var t_draw = 1;
        var t_fillCountry = 0.5;

        var d_fade = '+=0.1';

        var t_opacity = 0.35;
        var t_fade = 0.5;
        var t_draw = 1;
        var t_fillCountry = 0.5;

        var d_fade = '+=0.2';

        v.worldl
        .set($('#worldMap .line'), {strokeOpacity: 1})

        // LT

        .set($('#salis_64'), {fill: '#a7bad4', fillOpacity: 0})
        .set(lt_delivery, {fill: '#0d2862', fillOpacity: 0})
        // .set($('#Lietuva .line'), {strokeOpacity: 1})
        .to($('#salis_64'), t_opacity, {fillOpacity: 1}, t_opacity)
        .from($('#Lietuva .str1'), 1, {drawSVG: 0}, '-=0.2')
        .to(lt_delivery, t_fillCountry, {fillOpacity: 1}, '-=0.2')
        .to($('#Lietuva .fil2, #Lietuva .fil1'), 0.2, {autoAlpha: 1}, '-=0.35')
        .to($('#Lietuva .str1,#Lietuva .fil2, #Lietuva .fil1'), t_fade, {autoAlpha: 0}, d_fade)
        .to(lt_delivery, t_opacity, {fillOpacity: 0}, '-=0.2')
        .to($('#salis_64'), t_opacity, {fillOpacity: 0}, '-=0.6')

        // LV

        .set($('#salis_63'), {fill: '#a7bad4', fillOpacity: 0})
        .set(lv_delivery, {fill: '#0d2862', fillOpacity: 0})
        .to($('#salis_63'), t_opacity, {fillOpacity: 1})
        .from($('#Latvija .str1'), 1, {drawSVG: 0}, '-=0.2')
        .to(lv_delivery, t_fillCountry, {fillOpacity: 1}, '-=0.2')
        .to($('#Latvija .fil2, #Latvija .fil1'), 0.2, {autoAlpha: 1}, '-=0.35')
        .to($('#Latvija .str1,#Latvija .fil2, #Latvija .fil1'), t_fade, {autoAlpha: 0}, d_fade)
        .to(lv_delivery, t_opacity, {fillOpacity: 0}, '-=0.2')
        .to($('#salis_63'), t_opacity, {fillOpacity: 0}, '-=0.6')

        // EE

        .set($('#salis_106'), {fill: '#a7bad4', fillOpacity: 0})
        .set(ee_delivery, {fill: '#0d2862', fillOpacity: 0})
        .to($('#salis_106'), t_opacity, {fillOpacity: 1})
        .from($('#Estija .str1'), 1, {drawSVG: 0}, '-=0.2')
        .to(ee_delivery, t_fillCountry, {fillOpacity: 1}, '-=0.2')
        .to($('#Estija .fil2, #Estija .fil1'), 0.2, {autoAlpha: 1}, '-=0.35')
        .to($('#Estija .str1,#Estija .fil2, #Estija .fil1'), t_fade, {autoAlpha: 0}, d_fade)
        .to(ee_delivery, t_opacity, {fillOpacity: 0}, '-=0.2')
        .to($('#salis_106'), t_opacity, {fillOpacity: 0}, '-=0.6')
        //RU
        .set($('#salis_146'), {fill: '#a7bad4', fillOpacity: 0})
        .set(ru_delivery, {fill: '#0d2862', fillOpacity: 0})
        .to($('#salis_146'), t_opacity, {fillOpacity: 1})
        .from($('#Rusija .str1'), 1, {drawSVG: 0}, '-=0.2')
        .to(ru_delivery, t_fillCountry, {fillOpacity: 1}, '-=0.2')
        .to($('#Rusija .fil2, #Rusija .fil1'), 0.2, {autoAlpha: 1}, '-=0.35')
        .to($('#Rusija .str1,#Rusija .fil2, #Rusija .fil1'), t_fade, {autoAlpha: 0}, d_fade)
        .to(ru_delivery, t_opacity, {fillOpacity: 0}, '-=0.2')
        .to($('#salis_146'), t_opacity, {fillOpacity: 0}, '-=0.6')
        //DK

        .set($('#salis_169'), {fill: '#a7bad4', fillOpacity: 0})
        .set(dk_delivery, {fill: '#0d2862', fillOpacity: 0})
        .to($('#salis_169'), t_opacity, {fillOpacity: 1})
        .from($('#Danija .str1'), 1, {drawSVG: 0}, '-=0.2')
        .to(dk_delivery, t_fillCountry, {fillOpacity: 1}, '-=0.2')
        .to($('#Danija .fil2, #Danija .fil1'), 0.2, {autoAlpha: 1}, '-=0.35')
        .to($('#Danija .str1,#Danija .fil2, #Danija .fil1'), t_fade, {autoAlpha: 0}, d_fade )
        .to(dk_delivery, t_opacity, {fillOpacity: 0}, '-=0.2')
        .to($('#salis_169'), t_opacity, {fillOpacity: 0}, '-=0.6')
        // DE

        .set($('#salis_161'), {fill: '#a7bad4', fillOpacity: 0})
        .set(de_delivery, {fill: '#0d2862', fillOpacity: 0})
        .to($('#salis_161'), t_opacity, {fillOpacity: 1})
        .from($('#Vokietija .str1'), 1, {drawSVG: 0}, '-=0.2')
        .to(de_delivery, t_fillCountry, {fillOpacity: 1}, '-=0.2')
        .to($('#Vokietija .fil2, #Vokietija .fil1'), 0.2, {autoAlpha: 1}, '-=0.35')
        .to($('#Vokietija .str1,#Vokietija .fil2, #Vokietija .fil1'), t_fade, {autoAlpha: 0},  d_fade)
        .to(de_delivery, t_opacity, {fillOpacity: 0}, '-=0.2')
        .to($('#salis_161'), t_opacity, {fillOpacity: 0}, '-=0.6')
        //SE

        .set($('#salis_174'), {fill: '#a7bad4', fillOpacity: 0})
        .set(se_delivery, {fill: '#0d2862', fillOpacity: 0})
        .to($('#salis_174'), t_opacity, {fillOpacity: 1})
        .from($('#Svedija .str1'), 1, {drawSVG: 0}, '-=0.2')
        .to(se_delivery, t_fillCountry, {fillOpacity: 1}, '-=0.2')
        .to($('#Svedija .fil2, #Svedija .fil1'), 0.2, {autoAlpha: 1}, '-=0.35')
        .to($('#Svedija .str1,#Svedija .fil2, #Svedija .fil1'), t_fade, {autoAlpha: 0}, d_fade)
        .to(se_delivery, t_opacity, {fillOpacity: 0}, '-=0.2')
        .to($('#salis_174'), t_opacity, {fillOpacity: 0}, '-=0.6')
        //UA
        .set($('#salis_62'), {fill: '#a7bad4', fillOpacity: 0})
        .set(ua_delivery, {fill: '#0d2862', fillOpacity: 0})
        .to($('#salis_62'), t_opacity, {fillOpacity: 1})
        .from($('#Ukraina .str1'), 1, {drawSVG: 0}, '-=0.2')
        .to(ua_delivery, t_fillCountry, {fillOpacity: 1}, '-=0.2')
        .to($('#Ukraina .fil2, #Ukraina .fil1'), 0.2, {autoAlpha: 1}, '-=0.35')
        .to($('#Ukraina .str1,#Ukraina .fil2, #Ukraina .fil1'), t_fade, {autoAlpha: 0}, d_fade)
        .to(ua_delivery, t_opacity, {fillOpacity: 0}, '-=0.2')
        .to($('#salis_62'), t_opacity, {fillOpacity: 0}, '-=0.6')
        // UK
        .set($('#salis_171'), {fill: '#a7bad4', fillOpacity: 0})
        .set(uk_delivery, {fill: '#0d2862', fillOpacity: 0})
        .to($('#salis_171'), t_opacity, {fillOpacity: 1})
        .from($('#Anglija .str1'), 1, {drawSVG: 0}, '-=0.2')
        .to(uk_delivery, t_fillCountry, {fillOpacity: 1}, '-=0.2')
        .to($('#Anglija .fil2, #Anglija .fil1'), 0.2, {autoAlpha: 1}, '-=0.35')
        .to($('#Anglija .str1,#Anglija .fil2, #Anglija .fil1'), t_fade, {autoAlpha: 0}, d_fade)
        .to(uk_delivery, t_opacity, {fillOpacity: 0}, '-=0.2')
        .to($('#salis_171'), t_opacity, {fillOpacity: 0}, '-=0.6')
        //   FI

        .set($('#salis_175'), {fill: '#a7bad4', fillOpacity: 0})
        .set(fi_delivery, {fill: '#0d2862', fillOpacity: 0})
        .to($('#salis_175'), t_opacity, {fillOpacity: 1})
        .from($('#Suomija .str1'), 1, {drawSVG: 0}, '-=0.2')
        .to(fi_delivery, t_fillCountry, {fillOpacity: 1}, '-=0.2')
        .to($('#Suomija .fil2, #Suomija .fil1'), 0.2, {autoAlpha: 1}, '-=0.35')
        .to($('#Suomija .str1,#Suomija .fil2, #Suomija .fil1'), t_fade, {autoAlpha: 0}, d_fade)
        .to(fi_delivery, t_opacity, {fillOpacity: 0}, '-=0.2')
        .to($('#salis_175'), t_opacity, {fillOpacity: 0}, '-=0.6')

        //PL


        .set($('#salis_49'), {fill: '#a7bad4', fillOpacity: 0})
        .set(pl_delivery, {fill: '#0d2862', fillOpacity: 0})
        .to($('#salis_49'), t_opacity, {fillOpacity: 1})
        .from($('#Lenkija .str1'), 1, {drawSVG: 0}, '-=0.2')
        .to(pl_delivery, t_fillCountry, {fillOpacity: 1}, '-=0.2')
        .to($('#Lenkija .fil2, #Lenkija .fil1'), 0.2, {autoAlpha: 1}, '-=0.35')
        .to($('#Lenkija .str1,#Lenkija .fil2, #Lenkija .fil1'), t_fade, {autoAlpha: 0}, d_fade)
        .to(pl_delivery, t_opacity, {fillOpacity: 0}, '-=0.2')
        .to($('#salis_49'), t_opacity, {fillOpacity: 0}, '-=0.6');

        v.worldl.play().repeat(-1);
    },
    first: function(){

    },
    setWorld: function(){

    },
    unload: function(){
        $('.map-land--hover').off();
        page.checklist.zemelapis.scene.destroy($('.section-worldmap'));
        page.checklist.zemelapis.scene = null;

    },
    fadein: function(){

    },
    fadeout: function(){

    },
    calc: function(){

    },
    resize: function(){

    },
    scroll: function(){

    },
    v:{
        worldl:null,
        setWorld: null,
        interval: null
    }
}